import React from 'react';
import '../../styles/micro/collaborationvisual.scss';

const CollaborationVisual = () => {
  return (
    <div className="collab-visual">
      <div className="collab-visual__stack">
        {/* Bottom Layer - Foundation */}
        <div className="collab-visual__layer collab-visual__layer--bottom" />
        
        {/* Middle Layer - The Core/Work */}
        <div className="collab-visual__layer collab-visual__layer--middle">
          <div className="collab-visual__core-glow" />
        </div>
        
        {/* Top Layer - The Result/Interface */}
        <div className="collab-visual__layer collab-visual__layer--top" />
      </div>
    </div>
  );
};

export default CollaborationVisual;